import { Injectable } from '@angular/core';
import { Enums } from '../../route-planner/enums/route.enum';
import { MapContextMenuEvents, AAGoogleMapEvents } from 'src/app/core/events/events';
import { AALocationModel } from '../../route-planner/models/route-model';
import { EventsService } from 'src/app/core/services/events.service';
import { AppService } from '../../aa-core/services/app-service/app.service';
import { GoogleMapStoreService } from './google-map-store/google-map-store.service';
import { GoogleMapMarkerData } from '../models/google-map-model';
import { MarkerType, GoogleMapType } from '../enums/google-map-enum';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapEventHandlerService {

  constructor(private eventServices: EventsService,
    private appService: AppService,
    private googleMapStore: GoogleMapStoreService) {
      this.eventServices.on(AAGoogleMapEvents.MARKER_DRAG_END, this.markerDragEndHandler);
    }

    private markerDragEndHandler = (markerData: GoogleMapMarkerData) => {
      let routeType: Enums.RouteType;
      switch (markerData.type) {
        case MarkerType.ORIGIN:
          routeType = Enums.RouteType.FromDestination;
          break;

        case MarkerType.DESTINATION:
          routeType = Enums.RouteType.ToDestination;
          break;

        case MarkerType.WAYPOINT:
          routeType = Enums.RouteType.ViaDestination;
          break;
      }

      this.requestToAddNewLocation(routeType, markerData);
    }

    public requestToAddNewLocation(routeType: Enums.RouteType, markerData: GoogleMapMarkerData): void {
      const latLng =  markerData.draggedLatLng;

      if (latLng && routeType != undefined) {
          this.appService.getGeoLocationByLatLng(latLng).subscribe((data: any) => {
              const locationModel: AALocationModel =
              (data.error != undefined) ? this.createVirtualLocation(latLng, routeType) : this.createLocation(data, routeType);

              this.validateError(data);

              let action: MapContextMenuEvents;
              switch (routeType) {
                case Enums.RouteType.FromDestination:
                case Enums.RouteType.ToDestination:
                  action = MapContextMenuEvents.UPDATE_TO_LOCATION;
                  break;
                case Enums.RouteType.ViaDestination:
                  action = MapContextMenuEvents.UPDATE_VIA_LOCATION;
                  break;
              }
              // console.log('FINAL:', action, {locationModel:locationModel, index:markerData.id});
              this.eventServices.dispatch(action, {locationModel: locationModel, index: markerData.id});

              const googleMapModel = this.googleMapStore.getGoogleMapModel(GoogleMapType.ROUTE_PLANNER);
              googleMapModel.mapInstance.addRouteDirectionMarkers(true);
          });
      }
    }

    private createVirtualLocation(contextMenuLatLng, routeType: Enums.RouteType): AALocationModel {
        const name = `${contextMenuLatLng.lat.toFixed(6)}, ${contextMenuLatLng.lng.toFixed(6)}`;
        return new AALocationModel(name, contextMenuLatLng.lat, contextMenuLatLng.lng, routeType);
    }

    private createLocation(data: any, routeType: Enums.RouteType): AALocationModel {
        const locationModel = new AALocationModel(data.locationName, data.latlng.lat, data.latlng.lng, routeType);
        return locationModel;
    }

    private validateError(data: any): void {
        const hasError: boolean = (data.error != undefined);
        this.eventServices.dispatch(MapContextMenuEvents.ROUTE_DIRECTION_ERROR, hasError);
    }

}
